module.exports = __webpack_public_path__ + "static/media/store5.452826d3.jpg";